export default "__VITE_ASSET__AMQ667cT__"